module.exports = __webpack_public_path__ + "static/media/098-right button.82418e39.svg";